import type { FC, ReactNode } from 'react'

import Link from 'next/link'
import { cn } from '@/lib/utils'
import { RollText } from '@/components/site/roll-text'

type RollButtonSize = 'default' | 'big'

interface RollButtonProps {
    label: string
    href: string
    size?: RollButtonSize
    className?: string
    onClick?: () => void
}

const sizeClasses: Record<RollButtonSize, string> = {
    default: 'h-10 text-[18px]',
    big: 'h-14 text-[24px]'
}

export const rollButtonBase = 'roll-trigger inline-flex shrink-0 select-none items-center justify-center gap-4 overflow-clip bg-primary px-4 pb-2 pt-[10px] font-sans font-semibold uppercase leading-[0.9] tracking-normal text-primary-foreground'

export const RollButton: FC<RollButtonProps> = ({
    label,
    href,
    size = 'default',
    className,
    onClick
}): ReactNode => {
    return (
        <Link
            href={href}
            onClick={onClick}
            className={cn(rollButtonBase, sizeClasses[size], className)}
        >
            <RollText text={label} />
        </Link>
    )
}
